
import React, { useEffect, useState } from "react";
import { Row, Col } from "antd";
import useGetApi from "../../services/useGetApi";

const QuizDetailsCard = ({ courseId, sectionId, quizId }) => {
  const [loading, error, quizDetails, getQuizDetails] = useGetApi(`sections/course/${courseId}/section/${sectionId}/quiz/${quizId}`, null, false);
  const [quiz, setQuiz] = useState(null);


  useEffect(() => {
    getQuizDetails(`sections/course/${courseId}/section/${sectionId}/quiz/${quizId}`);
  }, [courseId, sectionId, quizId]);


  useEffect(() => {
    if (quizDetails) {
      setQuiz(quizDetails);
    }
  }, [quizDetails]);

  if (loading) return <div>Loading quiz details...</div>;
  if (error) return <div>Error loading quiz: {error}</div>;
  if (!quiz) return <div>No quiz data available</div>;

  return (
    <div>
      <Row justify="space-between" className="p-10">
        <Col>
          <h5>Title</h5>
          <p>{quiz.title}</p>
        </Col>
        <Col>
          <p className="mt-10">Total marks: {quiz.totalMarks}</p>
        </Col>
      </Row>
    </div>
  );
};

export default QuizDetailsCard;

